import {
	Box,
	Container,
	Grid,
	Typography,
	useMediaQuery,
	useTheme
} from '@mui/material';

import images from 'assets/images';

const SERVICES = [
	{
		icon: images.CoogoongIconVote,
		title: '투표',
		desc: '음원시상식/음악방송 순위 투표\n팬덤 참여/자체 기획 투표 콘텐츠'
	},
	{
		icon: images.CoogoongIconAd,
		title: '광고',
		desc: '글로벌 사용자 타겟에 맞는 광고 노출\n다양한 펀딩 상품을 통한 온-오프라인 응원 및 후원'
	},
	{
		icon: images.CoogoongIconCommunity,
		title: '커뮤니티',
		desc: 'K-POP 이슈 콘텐츠 랭킹\n이용자가 직접 생산하는 콘텐츠'
	},
	{
		icon: images.CoogoongIconMoment,
		title: '모먼트',
		desc: '글로벌 팬덤을 위한 K-POP 콘텐츠 큐레이션\n주제별, 시간별 카테고리에 맞는 정보 제공'
	},
	{
		icon: images.CoogoongIconCommerce,
		title: '커머스',
		desc: '자체 기획 굿즈\n글로벌 팬덤의 의견을 반영한 제품 온디맨드 유통'
	},
	{
		icon: images.CoogoongIconRookie,
		title: '슈퍼루키',
		desc: 'coogoong 기반 신인 아이돌 양성\n해외 진출 서포트 마케팅 사업'
	}
];

const Main = () => {
	const theme = useTheme();
	const matchUpSm = useMediaQuery(theme.breakpoints.up('sm'));
	const iconSize = matchUpSm ? 100 : 72;

	return (
		<Box component={'main'}>
			<Container maxWidth={'lg'}>
				{/* coogoong 정의 */}
				<Grid container py={15} px={matchUpSm ? 0 : '20px'}>
					<Grid
						item
						xs={12}
						display={'flex'}
						justifyContent={'center'}
						alignItems={'center'}
						flexWrap={'wrap'}
						gap={1.2}
					>
						<Typography
							component={'span'}
							sx={{
								fontSize: matchUpSm ? '40px' : '26px',
								fontWeight: 700,
								color: theme.palette.black[1],
								textAlign: 'center',
								lineHeight: 1.3
							}}
						>
							K-POP 팬덤이 직접 만들어가는 글로벌 플랫폼
						</Typography>
						<img
							src={images.CoogoongTitleLogo}
							alt={'coogoong'}
							style={{
								height: matchUpSm ? '52px' : '34px',
								width: 'auto',
								objectFit: 'contain',
								display: 'block'
							}}
						/>
					</Grid>
					<Grid item xs={12} display={'flex'} justifyContent={'center'} mt={3}>
						<Typography
							variant={matchUpSm ? 'caption2' : 'caption5'}
							color={theme.palette.grey[1]}
							textAlign={'center'}
							lineHeight={1.8}
						>
							글로벌 팬덤에 대한 배려와 서비스를 기반으로, K콘텐츠 타임라인
							아카이브 플랫폼으로 성장할
							<br />
							coogoong은 SMA, GOLDEN DISK, AAA 등 권위있는 K-POP 시상식 투표
							서비스를 비롯하여
							<br />
							차트, 펀딩, NFC 비즈니스 등 국내외 팬덤이 직접 만들어가는 다양한
							참여형 K콘텐츠 서비스를 진행 할 계획입니다.
						</Typography>
					</Grid>
				</Grid>
				{/* coogoong 서비스 소개 */}
				<Grid
					container
					pt={matchUpSm ? 10 : 6}
					pb={20}
					rowSpacing={matchUpSm ? 13 : 10}
					columnSpacing={2}
					px={matchUpSm ? 0 : '20px'}
				>
					{SERVICES.map((service) => (
						<Grid
							key={service.title}
							item
							xs={6}
							md={4}
							display={'flex'}
							flexDirection={'column'}
							alignItems={'center'}
						>
							<img
								src={service.icon}
								alt={service.title}
								width={iconSize}
								height={iconSize}
								style={{ objectFit: 'contain' }}
							/>
							<Typography
								variant={'h14'}
								color={theme.palette.black[1]}
								fontWeight={500}
								mt={3}
							>
								{service.title}
							</Typography>
							<Typography
								variant={matchUpSm ? 'caption2' : 'caption3'}
								color={theme.palette.grey[1]}
								textAlign={'center'}
								lineHeight={1.7}
								mt={2}
								whiteSpace={'pre-line'}
							>
								{service.desc}
							</Typography>
						</Grid>
					))}
				</Grid>
			</Container>
		</Box>
	);
};

export default Main;
